__webpack_require__.p = "https://dev.larrikin.club/";